// // // import React, { useState, useEffect } from 'react';
// // // import { Link } from 'react-router-dom';
// // // import styled, { keyframes } from 'styled-components';
// // // import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';
// // // import logoimage from './images/VVV_IT.png';

// // // const fadeIn = keyframes`
// // //   from {
// // //     opacity: 0;
// // //     transform: translateY(-10px);
// // //   }
// // //   to {
// // //     opacity: 1;
// // //     transform: translateY(0);
// // //   }
// // // `;

// // // const HeaderContainer = styled.header`
// // //   position: fixed;
// // //   top: 0;
// // //   left: 0;
// // //   right: 0;
// // //   z-index: 1000;
// // //   background: rgba(255, 255, 255, 0.95);
// // //   backdrop-filter: blur(10px);
// // //   box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
// // //   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
// // //   animation: ${fadeIn} 0.6s ease-out;

// // //   &.scrolled {
// // //     background: rgba(255, 255, 255, 0.98);
// // //     box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
// // //   }
// // // `;

// // // const HeaderContent = styled.div`
// // //   max-width: 1400px;
// // //   margin: 0 auto;
// // //   padding: 1rem 2rem;
// // //   display: flex;
// // //   justify-content: space-between;
// // //   align-items: center;
// // //   position: relative;
// // // `;

// // // const LogoText = styled(Link)`
// // //   display: flex;
// // //   align-items: center;
// // //   gap: 1.2rem;
// // //   cursor: pointer;
// // //   transition: all 0.3s ease;
// // //   text-decoration: none;
// // //   position: relative;
// // //   padding: 0.5rem;

// // //   &::after {
// // //     content: '';
// // //     position: absolute;
// // //     bottom: 0;
// // //     left: 0;
// // //     width: 100%;
// // //     height: 2px;
// // //     background: linear-gradient(90deg, #00A896, transparent);
// // //     transform: scaleX(0);
// // //     transform-origin: right;
// // //     transition: transform 0.4s ease;
// // //   }

// // //   &:hover::after {
// // //     transform: scaleX(1);
// // //     transform-origin: left;
// // //   }

// // //   img {
// // //     width: 65px;
// // //     height: 65px;
// // //     object-fit: contain;
// // //     transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
// // //     filter: drop-shadow(0 4px 8px rgba(10, 35, 66, 0.15));
// // //   }

// // //   &:hover img {
// // //     transform: scale(1.1) rotate(5deg);
// // //     filter: drop-shadow(0 6px 12px rgba(10, 35, 66, 0.2));
// // //   }
// // // `;

// // // const ContactInfo = styled.div`
// // //   display: flex;
// // //   flex-direction: column;
// // //   align-items: flex-end;
// // //   gap: 0.5rem;
// // //   margin-right: 2rem;
// // //   color: #333;
// // //   font-size: 0.9rem;
// // //   position: relative;

// // //   @media (max-width: 768px) {
// // //     display: none;
// // //   }

// // //   &::before {
// // //     content: '';
// // //     position: absolute;
// // //     right: -1rem;
// // //     top: 0;
// // //     bottom: 0;
// // //     width: 1px;
// // //     background: linear-gradient(to bottom, transparent, #00A896, transparent);
// // //   }
// // // `;

// // // const ContactItem = styled.div`
// // //   display: flex;
// // //   align-items: center;
// // //   gap: 0.5rem;
// // //   padding: 0.3rem 0.5rem;
// // //   border-radius: 6px;
// // //   transition: all 0.3s ease;
// // //   background: rgba(0, 168, 150, 0.05);

// // //   &:hover {
// // //     background: rgba(0, 168, 150, 0.1);
// // //     transform: translateX(-5px);
// // //   }

// // //   svg {
// // //     color: #00A896;
// // //     font-size: 1rem;
// // //     flex-shrink: 0;
// // //   }

// // //   a {
// // //     color: #333;
// // //     text-decoration: none;
// // //     transition: color 0.3s ease;
// // //     display: flex;
// // //     align-items: center;
// // //     gap: 0.3rem;

// // //     &:hover {
// // //       color: #00A896;
// // //     }
// // //   }
// // // `;

// // // const MobileContactInfo = styled.div`
// // //   display: none;
// // //   flex-direction: column;
// // //   gap: 1rem;
// // //   padding: 1rem;
// // //   background: rgba(255, 255, 255, 0.95);
// // //   border-radius: 10px;
// // //   margin: 1rem 0;

// // //   @media (max-width: 768px) {
// // //     display: flex;
// // //   }
// // // `;

// // // const Nav = styled.nav`
// // //   display: flex;
// // //   gap: 2.5rem;
// // //   align-items: center;
// // //   position: relative;

// // //   @media (max-width: 1024px) {
// // //     gap: 2rem;
// // //   }

// // //   @media (max-width: 768px) {
// // //     display: none;
// // //   }
// // // `;

// // // const NavLink = styled(Link)`
// // //   color: #333;
// // //   text-decoration: none;
// // //   font-weight: 500;
// // //   font-size: 1rem;
// // //   position: relative;
// // //   padding: 0.5rem 0;
// // //   transition: all 0.3s ease;

// // //   &::before {
// // //     content: '';
// // //     position: absolute;
// // //     bottom: 0;
// // //     left: 0;
// // //     width: 100%;
// // //     height: 2px;
// // //     background: linear-gradient(90deg, #00A896, transparent);
// // //     transform: scaleX(0);
// // //     transform-origin: right;
// // //     transition: transform 0.3s ease;
// // //   }

// // //   &:hover {
// // //     color: #00A896;
    
// // //     &::before {
// // //       transform: scaleX(1);
// // //       transform-origin: left;
// // //     }
// // //   }

// // //   &.active {
// // //     color: #00A896;
// // //     &::before {
// // //       transform: scaleX(1);
// // //     }
// // //   }
// // // `;

// // // const CTAButton = styled(Link)`
// // //   background: linear-gradient(135deg, #00A896, #008a79);
// // //   color: white;
// // //   padding: 0.8rem 1.8rem;
// // //   border-radius: 50px;
// // //   text-decoration: none;
// // //   font-weight: 600;
// // //   font-size: 1rem;
// // //   transition: all 0.3s ease;
// // //   box-shadow: 0 4px 15px rgba(0, 168, 150, 0.3);
// // //   position: relative;
// // //   overflow: hidden;
// // //   letter-spacing: 0.5px;
// // //   border: none;

// // //   &::before {
// // //     content: '';
// // //     position: absolute;
// // //     top: 0;
// // //     left: -100%;
// // //     width: 100%;
// // //     height: 100%;
// // //     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
// // //     transition: 0.5s;
// // //   }

// // //   &:hover {
// // //     transform: translateY(-2px);
// // //     box-shadow: 0 6px 20px rgba(0, 168, 150, 0.4);
    
// // //     &::before {
// // //       left: 100%;
// // //     }
// // //   }
// // // `;

// // // const MobileMenuButton = styled.button`
// // //   display: none;
// // //   background: none;
// // //   border: none;
// // //   cursor: pointer;
// // //   padding: 0.5rem;
// // //   z-index: 1001;
// // //   color: #00A896;
// // //   transition: transform 0.3s ease;

// // //   @media (max-width: 768px) {
// // //     display: block;
// // //   }

// // //   &:hover {
// // //     transform: scale(1.1);
// // //   }
// // // `;

// // // const MobileMenu = styled.div`
// // //   position: fixed;
// // //   top: 0;
// // //   right: 0;
// // //   width: 100%;
// // //   height: 100vh;
// // //   background: rgba(255, 255, 255, 0.98);
// // //   backdrop-filter: blur(10px);
// // //   transform: translateX(${props => props.isOpen ? '0' : '100%'});
// // //   transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
// // //   padding: 6rem 2rem 2rem;
// // //   display: flex;
// // //   flex-direction: column;
// // //   align-items: center;
// // //   justify-content: flex-start;
// // //   gap: 1.5rem;
// // //   z-index: 1000;
// // //   box-shadow: -5px 0 30px rgba(0, 0, 0, 0.1);

// // //   @media (min-width: 769px) {
// // //     display: none;
// // //   }
// // // `;

// // // const MobileNavLink = styled(NavLink)`
// // //   font-size: 1.4rem;
// // //   padding: 0.8rem 0;
// // //   text-align: center;
// // //   width: 100%;
// // //   max-width: 250px;
// // //   color: #333;

// // //   &:hover {
// // //     color: #00A896;
// // //   }
// // // `;

// // // const CloseButton = styled.button`
// // //   position: absolute;
// // //   top: 1.5rem;
// // //   right: 1.5rem;
// // //   background: none;
// // //   border: none;
// // //   font-size: 2.2rem;
// // //   color: #00A896;
// // //   cursor: pointer;
// // //   padding: 0.5rem;
// // //   line-height: 1;
// // //   transition: all 0.3s ease;

// // //   &:hover {
// // //     transform: rotate(90deg) scale(1.1);
// // //   }
// // // `;

// // // const NavItem = styled.div`
// // //     position: relative;
// // //     display: flex;
// // //     align-items: center;
// // //     cursor: pointer;

// // //     &:hover > div {
// // //         // display: block;
// // //     }
// // // `;

// // // const DropdownMenu = styled.div`
// // //     display: ${props => props.isOpen ? 'block' : 'none'};
// // //     position: absolute;
// // //     top: calc(100% + 10px);
// // //     left: 50%;
// // //     transform: translateX(-50%);
// // //     background: white;
// // //     min-width: 220px;
// // //     border-radius: 8px;
// // //     box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
// // //     padding: 8px 0;
// // //     z-index: 1000;
// // //     opacity: ${props => props.isOpen ? 1 : 0};
// // //     visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
// // //     transition: opacity 0.2s ease, visibility 0.2s ease;

// // //     &::before {
// // //       content: '';
// // //       position: absolute;
// // //       top: -5px;
// // //       left: 50%;
// // //       transform: translateX(-50%);
// // //       width: 0;
// // //       height: 0;
// // //       border-left: 6px solid transparent;
// // //       border-right: 6px solid transparent;
// // //       border-bottom: 6px solid white;
// // //     }
// // // `;

// // // const DropdownItem = styled(Link)`
// // //     display: block;
// // //     padding: 10px 20px;
// // //     color: #333333;
// // //     text-decoration: none;
// // //     font-size: 0.95rem;
// // //     transition: background-color 0.2s ease, color 0.2s ease;
// // //     white-space: nowrap;

// // //     &:hover {
// // //         background-color: #F8F9FA;
// // //         color: #00A896;
// // //     }
// // // `;

// // // const Header = () => {
// // //   const [isScrolled, setIsScrolled] = useState(false);
// // //   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
// // //   const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);

// // //   useEffect(() => {
// // //     const handleScroll = () => {
// // //       setIsScrolled(window.scrollY > 20);
// // //     };

// // //     window.addEventListener('scroll', handleScroll);
// // //     return () => window.removeEventListener('scroll', handleScroll);
// // //   }, []);

// // //   const closeMobileMenu = () => setIsMobileMenuOpen(false);

// // //   return (
// // //     <HeaderContainer className={isScrolled ? 'scrolled' : ''}>
// // //       <HeaderContent>
// // //         <LogoText to="/">
// // //           <img src={logoimage} alt="VVV IT Solutions Logo" />
// // //         </LogoText>

// // //         <ContactInfo>
// // //           <ContactItem>
// // //             <FaMapMarkerAlt />
// // //             <span>109/421, 80 feet road, Kanpur(U.P), India</span>
// // //           </ContactItem>
// // //           <ContactItem>
// // //             <FaPhone />
// // //             <a href="tel:+919336652601">+91-9336652601</a>
// // //             <span style={{ color: '#666' }}>|</span>
// // //             <a href="tel:+919519510543">9519510543</a>
// // //           </ContactItem>
// // //           <ContactItem>
// // //             <FaEnvelope />
// // //             <a href="mailto:shivnaresh@gmail.com">shivnaresh@gmail.com</a>
// // //           </ContactItem>
// // //         </ContactInfo>

// // //         <Nav>
// // //           <NavLink to="/">Home</NavLink>
// // //           <NavLink to="/about">About</NavLink>
// // //           <NavItem
// // //             onMouseEnter={() => setIsServicesDropdownOpen(true)}
// // //             onMouseLeave={() => setIsServicesDropdownOpen(false)}
// // //           >
// // //             <NavLink to="/services">Services</NavLink>
// // //             <DropdownMenu isOpen={isServicesDropdownOpen}>
// // //               <DropdownItem to="/services/web-development" onClick={() => setIsServicesDropdownOpen(false)}>Web Development</DropdownItem>
// // //               <DropdownItem to="/services/mobile-development" onClick={() => setIsServicesDropdownOpen(false)}>Mobile App Development</DropdownItem>
// // //               <DropdownItem to="/services/cloud-solutions" onClick={() => setIsServicesDropdownOpen(false)}>Cloud Solutions</DropdownItem>
// // //               <DropdownItem to="/services/it-security" onClick={() => setIsServicesDropdownOpen(false)}>IT Security</DropdownItem>
// // //             </DropdownMenu>
// // //           </NavItem>
// // //           <NavLink to="/career">Career</NavLink>
// // //           <NavLink to="/contact">Contact</NavLink>
// // //           <CTAButton to="/contact">Get Started</CTAButton>
// // //         </Nav>

// // //         <MobileMenuButton
// // //           onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
// // //           aria-label="Toggle mobile menu"
// // //         >
// // //           {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
// // //         </MobileMenuButton>

// // //         <MobileMenu isOpen={isMobileMenuOpen}>
// // //           <CloseButton onClick={closeMobileMenu} aria-label="Close mobile menu">&times;</CloseButton>
          
// // //           <MobileContactInfo>
// // //             <ContactItem>
// // //               <FaMapMarkerAlt />
// // //               <span>109/421, 80 feet road, Kanpur(U.P), India</span>
// // //             </ContactItem>
// // //             <ContactItem>
// // //               <FaPhone />
// // //               <a href="tel:+919336652601">+91-9336652601</a>
// // //             </ContactItem>
// // //             <ContactItem>
// // //               <FaPhone />
// // //               <a href="tel:+919519510543">9519510543</a>
// // //             </ContactItem>
// // //             <ContactItem>
// // //               <FaEnvelope />
// // //               <a href="mailto:shivnaresh@gmail.com">shivnaresh@gmail.com</a>
// // //             </ContactItem>
// // //           </MobileContactInfo>

// // //           <MobileNavLink to="/" onClick={closeMobileMenu}>Home</MobileNavLink>
// // //           <MobileNavLink to="/about" onClick={closeMobileMenu}>About</MobileNavLink>
// // //           <MobileNavLink to="/services" onClick={closeMobileMenu}>Services</MobileNavLink>
// // //           <MobileNavLink style={{fontSize: '1.1rem', paddingLeft: '20px'}} to="/services/web-development" onClick={closeMobileMenu}>- Web Development</MobileNavLink>
// // //           <MobileNavLink style={{fontSize: '1.1rem', paddingLeft: '20px'}} to="/services/mobile-development" onClick={closeMobileMenu}>- Mobile App Development</MobileNavLink>
// // //           <MobileNavLink style={{fontSize: '1.1rem', paddingLeft: '20px'}} to="/services/cloud-solutions" onClick={closeMobileMenu}>- Cloud Solutions</MobileNavLink>
// // //           <MobileNavLink style={{fontSize: '1.1rem', paddingLeft: '20px'}} to="/services/it-security" onClick={closeMobileMenu}>- IT Security</MobileNavLink>
// // //           <MobileNavLink to="/career" onClick={closeMobileMenu}>Career</MobileNavLink>
// // //           <MobileNavLink to="/contact" onClick={closeMobileMenu}>Contact</MobileNavLink>
// // //           <CTAButton to="/contact" onClick={closeMobileMenu} style={{marginTop: '2rem'}}>Get Started</CTAButton>
// // //         </MobileMenu>
// // //       </HeaderContent>
// // //     </HeaderContainer>
// // //   );
// // // };

// // // export default Header;

// // import React, { useState, useEffect } from 'react';
// // import { Link, useLocation } from 'react-router-dom';
// // import styled, { keyframes } from 'styled-components';
// // import { 
// //   FaBars, 
// //   FaTimes, 
// //   FaChevronDown,
// //   FaChevronRight
// // } from 'react-icons/fa';
// // import logoimage from './images/VVV_IT.png';

// // // Animations
// // const fadeInDown = keyframes`
// //   from {
// //     opacity: 0;
// //     transform: translateY(-20px);
// //   }
// //   to {
// //     opacity: 1;
// //     transform: translateY(0);
// //   }
// // `;

// // const fadeIn = keyframes`
// //   from {
// //     opacity: 0;
// //   }
// //   to {
// //     opacity: 1;
// //   }
// // `;

// // const slideInDown = keyframes`
// //   from {
// //     opacity: 0;
// //     transform: translateY(-20px);
// //   }
// //   to {
// //     opacity: 1;
// //     transform: translateY(0);
// //   }
// // `;

// // // Styled Components
// // const HeaderContainer = styled.header`
// //   position: fixed;
// //   top: 0;
// //   left: 0;
// //   right: 0;
// //   z-index: 1000;
// //   background: ${props => props.scrolled ? 'rgba(255, 255, 255, 0.98)' : 'rgba(255, 255, 255, 0.95)'};
// //   backdrop-filter: blur(20px);
// //   box-shadow: ${props => props.scrolled ? '0 8px 32px rgba(0, 0, 0, 0.12)' : '0 4px 20px rgba(0, 0, 0, 0.08)'};
// //   border-bottom: 1px solid rgba(255, 255, 255, 0.2);
// //   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
// //   animation: ${fadeInDown} 0.6s ease-out;

// //   @media (max-width: 768px) {
// //     backdrop-filter: blur(30px);
// //   }
// // `;

// // const HeaderContent = styled.div`
// //   max-width: 1400px;
// //   margin: 0 auto;
// //   padding: 1rem 2rem;
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// //   position: relative;

// //   @media (max-width: 1024px) {
// //     padding: 1rem 1.5rem;
// //   }

// //   @media (max-width: 768px) {
// //     padding: 0.8rem 1.2rem;
// //   }
// // `;

// // const LogoContainer = styled(Link)`
// //   display: flex;
// //   align-items: center;
// //   gap: 1rem;
// //   cursor: pointer;
// //   text-decoration: none;
// //   position: relative;
// //   padding: 0.5rem;
// //   border-radius: 12px;
// //   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

// //   &:hover {
// //     transform: translateY(-2px);
    
// //     img {
// //       transform: scale(1.1) rotate(5deg);
// //       filter: drop-shadow(0 6px 12px rgba(10, 35, 66, 0.25));
// //     }
// //   }
// // `;

// // const LogoImage = styled.img`
// //   width: 65px;
// //   height: 65px;
// //   object-fit: contain;
// //   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
// //   filter: drop-shadow(0 4px 8px rgba(10, 35, 66, 0.15));

// //   @media (max-width: 768px) {
// //     width: 55px;
// //     height: 55px;
// //   }

// //   @media (max-width: 480px) {
// //     width: 50px;
// //     height: 50px;
// //   }
// // `;

// // const LogoText = styled.div`
// //   display: flex;
// //   flex-direction: column;

// //   @media (max-width: 1024px) {
// //     display: none;
// //   }
// // `;

// // const CompanyName = styled.div`
// //   font-size: 1.4rem;
// //   font-weight: 800;
// //   color: #0A2342;
// //   line-height: 1.1;
// //   letter-spacing: -0.02em;
// // `;

// // const CompanyTagline = styled.div`
// //   font-size: 0.75rem;
// //   color: #00A896;
// //   font-weight: 600;
// //   text-transform: uppercase;
// //   letter-spacing: 1px;
// //   margin-top: 2px;
// // `;

// // const Nav = styled.nav`
// //   display: flex;
// //   gap: 2.5rem;
// //   align-items: center;
// //   position: relative;

// //   @media (max-width: 1024px) {
// //     gap: 2rem;
// //   }

// //   @media (max-width: 900px) {
// //     display: none;
// //   }
// // `;

// // const NavLink = styled(Link)`
// //   color: ${props => props.active ? '#00A896' : '#334155'};
// //   text-decoration: none;
// //   font-weight: 600;
// //   font-size: 1rem;
// //   position: relative;
// //   padding: 0.8rem 0;
// //   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
// //   letter-spacing: -0.01em;
// //   white-space: nowrap;

// //   &::before {
// //     content: '';
// //     position: absolute;
// //     bottom: 0;
// //     left: 0;
// //     width: 100%;
// //     height: 3px;
// //     background: linear-gradient(90deg, #00A896, #005f56);
// //     transform: scaleX(0);
// //     transform-origin: right;
// //     transition: transform 0.4s ease;
// //     border-radius: 2px;
// //   }

// //   &:hover {
// //     color: #00A896;
    
// //     &::before {
// //       transform: scaleX(1);
// //       transform-origin: left;
// //     }
// //   }

// //   &.active {
// //     color: #00A896;
    
// //     &::before {
// //       transform: scaleX(1);
// //     }
// //   }
// // `;

// // const NavItem = styled.div`
// //   position: relative;
// //   display: flex;
// //   align-items: center;
// //   cursor: pointer;

// //   &:hover > div {
// //     opacity: 1;
// //     visibility: visible;
// //     transform: translateY(0);
// //   }
// // `;

// // const DropdownMenu = styled.div`
// //   position: absolute;
// //   top: calc(100% + 10px);
// //   left: 50%;
// //   transform: translateX(-50%) translateY(-10px);
// //   background: rgba(255, 255, 255, 0.98);
// //   backdrop-filter: blur(20px);
// //   min-width: 240px;
// //   border-radius: 16px;
// //   box-shadow: 
// //     0 20px 40px rgba(0, 0, 0, 0.15),
// //     0 0 0 1px rgba(0, 0, 0, 0.05);
// //   padding: 12px 0;
// //   z-index: 1000;
// //   opacity: 0;
// //   visibility: hidden;
// //   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
// //   border: 1px solid rgba(255, 255, 255, 0.2);

// //   &::before {
// //     content: '';
// //     position: absolute;
// //     top: -6px;
// //     left: 50%;
// //     transform: translateX(-50%);
// //     width: 0;
// //     height: 0;
// //     border-left: 6px solid transparent;
// //     border-right: 6px solid transparent;
// //     border-bottom: 6px solid rgba(255, 255, 255, 0.98);
// //   }
// // `;

// // const DropdownItem = styled(Link)`
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   padding: 12px 20px;
// //   color: #334155;
// //   text-decoration: none;
// //   font-size: 0.95rem;
// //   font-weight: 500;
// //   transition: all 0.2s ease;
// //   border-left: 3px solid transparent;

// //   &:hover {
// //     background: rgba(0, 168, 150, 0.08);
// //     color: #00A896;
// //     border-left-color: #00A896;
// //     padding-left: 24px;

// //     svg {
// //       opacity: 1;
// //       transform: translateX(3px);
// //     }
// //   }

// //   svg {
// //     opacity: 0;
// //     transition: all 0.3s ease;
// //     font-size: 0.8rem;
// //   }
// // `;

// // const CTAButton = styled(Link)`
// //   background: linear-gradient(135deg, #00A896, #008a79);
// //   color: white;
// //   padding: 0.9rem 2.2rem;
// //   border-radius: 50px;
// //   text-decoration: none;
// //   font-weight: 700;
// //   font-size: 1rem;
// //   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
// //   box-shadow: 
// //     0 8px 20px rgba(0, 168, 150, 0.3),
// //     inset 0 1px 0 rgba(255, 255, 255, 0.2);
// //   position: relative;
// //   overflow: hidden;
// //   letter-spacing: 0.3px;
// //   border: none;
// //   white-space: nowrap;

// //   &::before {
// //     content: '';
// //     position: absolute;
// //     top: 0;
// //     left: -100%;
// //     width: 100%;
// //     height: 100%;
// //     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
// //     transition: left 0.6s ease;
// //   }

// //   &:hover {
// //     transform: translateY(-2px);
// //     box-shadow: 
// //       0 12px 25px rgba(0, 168, 150, 0.4),
// //       inset 0 1px 0 rgba(255, 255, 255, 0.2);
    
// //     &::before {
// //       left: 100%;
// //     }
// //   }

// //   @media (max-width: 900px) {
// //     padding: 0.8rem 1.8rem;
// //     font-size: 0.95rem;
// //   }
// // `;

// // const MobileMenuButton = styled.button`
// //   display: none;
// //   background: none;
// //   border: none;
// //   cursor: pointer;
// //   padding: 0.8rem;
// //   z-index: 1001;
// //   color: #00A896;
// //   transition: all 0.3s ease;
// //   border-radius: 10px;
// //   position: relative;

// //   @media (max-width: 900px) {
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //   }

// //   &:hover {
// //     background: rgba(0, 168, 150, 0.1);
// //     transform: scale(1.05);
// //   }
// // `;

// // const MobileMenuOverlay = styled.div`
// //   position: fixed;
// //   top: 0;
// //   left: 0;
// //   width: 100%;
// //   height: 100vh;
// //   background: rgba(255, 255, 255, 0.98);
// //   backdrop-filter: blur(30px);
// //   z-index: 998;
// //   display: ${props => props.isOpen ? 'flex' : 'none'};
// //   flex-direction: column;
// //   align-items: center;
// //   justify-content: flex-start;
// //   padding-top: 5rem;
// //   animation: ${fadeIn} 0.3s ease;
// //   overflow: hidden;

// //   @media (min-width: 901px) {
// //     display: none;
// //   }
// // `;

// // const CloseButton = styled.button`
// //   position: fixed;
// //   top: 1.5rem;
// //   right: 1.5rem;
// //   background: none;
// //   border: none;
// //   color: #00A896;
// //   cursor: pointer;
// //   padding: 0.5rem;
// //   line-height: 1;
// //   transition: all 0.3s ease;
// //   border-radius: 10px;
// //   width: 45px;
// //   height: 45px;
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   z-index: 1002;

// //   &:hover {
// //     transform: rotate(90deg) scale(1.1);
// //     background: rgba(0, 168, 150, 0.1);
// //   }
// // `;

// // const MobileNavContent = styled.div`
// //   width: 100%;
// //   max-width: 500px;
// //   height: calc(100vh - 6rem);
// //   padding: 0 2rem 2rem;
// //   display: flex;
// //   flex-direction: column;
// //   align-items: stretch;
// //   gap: 0;
// //   overflow-y: auto;
// //   -webkit-overflow-scrolling: touch;

// //   /* Scrollbar Styling */
// //   &::-webkit-scrollbar {
// //     width: 4px;
// //   }

// //   &::-webkit-scrollbar-track {
// //     background: rgba(0, 0, 0, 0.05);
// //     border-radius: 10px;
// //   }

// //   &::-webkit-scrollbar-thumb {
// //     background: #00A896;
// //     border-radius: 10px;
// //   }

// //   &::-webkit-scrollbar-thumb:hover {
// //     background: #008a79;
// //   }

// //   @media (max-width: 480px) {
// //     padding: 0 1.5rem 2rem;
// //     height: calc(100vh - 5rem);
// //   }
// // `;

// // const MobileNavLink = styled(Link)`
// //   color: ${props => props.active ? '#00A896' : '#334155'};
// //   text-decoration: none;
// //   font-weight: 600;
// //   font-size: 1.2rem;
// //   padding: 1.2rem 1rem;
// //   border-bottom: 1px solid rgba(0, 0, 0, 0.08);
// //   transition: all 0.3s ease;
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   text-transform: none;
// //   letter-spacing: normal;
// //   animation: ${slideInDown} 0.4s ease;
// //   flex-shrink: 0;

// //   &:hover {
// //     color: #00A896;
// //     background: rgba(0, 168, 150, 0.05);
// //     padding-left: 1.5rem;
// //   }

// //   &.active {
// //     color: #00A896;
// //     background: rgba(0, 168, 150, 0.08);
// //   }

// //   @media (max-width: 480px) {
// //     font-size: 1.1rem;
// //     padding: 1rem 1rem;
// //   }
// // `;

// // const MobileSubMenu = styled.div`
// //   display: ${props => props.isOpen ? 'flex' : 'none'};
// //   flex-direction: column;
// //   background: rgba(0, 0, 0, 0.02);
// //   border-radius: 8px;
// //   margin: 0.5rem 0;
// //   overflow: hidden;
// //   animation: ${slideInDown} 0.4s ease;
// //   flex-shrink: 0;
// // `;

// // const MobileSubLink = styled(Link)`
// //   color: #64748b;
// //   text-decoration: none;
// //   font-weight: 500;
// //   font-size: 1rem;
// //   padding: 1rem 1.5rem;
// //   border-bottom: 1px solid rgba(0, 0, 0, 0.05);
// //   transition: all 0.3s ease;
// //   display: flex;
// //   align-items: center;
// //   text-transform: none;
// //   letter-spacing: normal;
// //   flex-shrink: 0;

// //   &:hover {
// //     color: #00A896;
// //     background: rgba(0, 168, 150, 0.05);
// //     padding-left: 2rem;
// //   }

// //   &:last-child {
// //     border-bottom: none;
// //   }
// // `;

// // const ServicesToggle = styled.div`
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   width: 100%;
// //   cursor: pointer;
// //   text-transform: none;
// //   letter-spacing: normal;
// // `;

// // const MobileNavItem = styled.div`
// //   color: ${props => props.active ? '#00A896' : '#334155'};
// //   text-decoration: none;
// //   font-weight: 600;
// //   font-size: 1.2rem;
// //   padding: 1.2rem 1rem;
// //   border-bottom: 1px solid rgba(0, 0, 0, 0.08);
// //   transition: all 0.3s ease;
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   text-transform: none;
// //   letter-spacing: normal;
// //   cursor: pointer;
// //   animation: ${slideInDown} 0.4s ease;
// //   flex-shrink: 0;

// //   &:hover {
// //     color: #00A896;
// //     background: rgba(0, 168, 150, 0.05);
// //     padding-left: 1.5rem;
// //   }

// //   @media (max-width: 480px) {
// //     font-size: 1.1rem;
// //     padding: 1rem 1rem;
// //   }
// // `;

// // const Header = () => {
// //   const [isScrolled, setIsScrolled] = useState(false);
// //   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
// //   const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
// //   const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
// //   const location = useLocation();

// //   useEffect(() => {
// //     const handleScroll = () => {
// //       setIsScrolled(window.scrollY > 10);
// //     };

// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   const closeMobileMenu = () => {
// //     setIsMobileMenuOpen(false);
// //     setIsMobileServicesOpen(false);
// //   };

// //   const isActiveLink = (path) => {
// //     return location.pathname === path;
// //   };

// //   const toggleMobileServices = () => {
// //     setIsMobileServicesOpen(!isMobileServicesOpen);
// //   };

// //   return (
// //     <HeaderContainer scrolled={isScrolled}>
// //       <HeaderContent>
// //         <LogoContainer to="/" onClick={closeMobileMenu}>
// //           <LogoImage src={logoimage} alt="VVV IT Solutions Logo" />
// //           <LogoText>
// //             <CompanyName>VVV IT Solutions</CompanyName>
// //             <CompanyTagline>Digital Innovation</CompanyTagline>
// //           </LogoText>
// //         </LogoContainer>

// //         <Nav>
// //           <NavLink to="/" active={isActiveLink('/')}>Home</NavLink>
// //           <NavLink to="/about" active={isActiveLink('/about')}>About</NavLink>
// //           <NavItem
// //             onMouseEnter={() => setIsServicesDropdownOpen(true)}
// //             onMouseLeave={() => setIsServicesDropdownOpen(false)}
// //           >
// //             <NavLink to="/services" active={isActiveLink('/services')}>
// //               Services <FaChevronDown size={12} style={{ marginLeft: '6px' }} />
// //             </NavLink>
// //             <DropdownMenu style={{ 
// //               opacity: isServicesDropdownOpen ? 1 : 0, 
// //               visibility: isServicesDropdownOpen ? 'visible' : 'hidden',
// //               transform: isServicesDropdownOpen ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(-10px)'
// //             }}>
// //               <DropdownItem to="/services/web-development" onClick={() => setIsServicesDropdownOpen(false)}>
// //                 Web Development
// //                 <FaChevronRight />
// //               </DropdownItem>
// //               <DropdownItem to="/services/mobile-development" onClick={() => setIsServicesDropdownOpen(false)}>
// //                 Mobile App Development
// //                 <FaChevronRight />
// //               </DropdownItem>
// //               <DropdownItem to="/services/cloud-solutions" onClick={() => setIsServicesDropdownOpen(false)}>
// //                 Cloud Solutions
// //                 <FaChevronRight />
// //               </DropdownItem>
// //               <DropdownItem to="/services/it-security" onClick={() => setIsServicesDropdownOpen(false)}>
// //                 IT Security
// //                 <FaChevronRight />
// //               </DropdownItem>
// //             </DropdownMenu>
// //           </NavItem>
// //           <NavLink to="/career" active={isActiveLink('/career')}>Career</NavLink>
// //           <NavLink to="/contact" active={isActiveLink('/contact')}>Contact</NavLink>
// //           <CTAButton to="/contact">Get Started</CTAButton>
// //         </Nav>

// //         <MobileMenuButton
// //           onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
// //           aria-label="Toggle mobile menu"
// //         >
// //           {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
// //         </MobileMenuButton>

// //         <MobileMenuOverlay isOpen={isMobileMenuOpen}>
// //           <CloseButton onClick={closeMobileMenu} aria-label="Close mobile menu">
// //             <FaTimes size={20} />
// //           </CloseButton>
          
// //           <MobileNavContent>
// //             <MobileNavLink to="/" onClick={closeMobileMenu} active={isActiveLink('/')}>
// //               <span>Home</span>
// //               <FaChevronRight size={14} />
// //             </MobileNavLink>
            
// //             <MobileNavLink to="/about" onClick={closeMobileMenu} active={isActiveLink('/about')}>
// //               <span>About</span>
// //               <FaChevronRight size={14} />
// //             </MobileNavLink>
            
// //             <MobileNavItem 
// //               onClick={toggleMobileServices}
// //               active={isActiveLink('/services')}
// //             >
// //               <ServicesToggle>
// //                 <span>Services</span>
// //                 <FaChevronRight 
// //                   size={14} 
// //                   style={{ 
// //                     transform: isMobileServicesOpen ? 'rotate(90deg)' : 'rotate(0deg)',
// //                     transition: 'transform 0.3s ease'
// //                   }} 
// //                 />
// //               </ServicesToggle>
// //             </MobileNavItem>
            
// //             <MobileSubMenu isOpen={isMobileServicesOpen}>
// //               <MobileSubLink to="/services/web-development" onClick={closeMobileMenu}>
// //                 <span>Web Development</span>
// //               </MobileSubLink>
// //               <MobileSubLink to="/services/mobile-development" onClick={closeMobileMenu}>
// //                 <span>Mobile App Development</span>
// //               </MobileSubLink>
// //               <MobileSubLink to="/services/cloud-solutions" onClick={closeMobileMenu}>
// //                 <span>Cloud Solutions</span>
// //               </MobileSubLink>
// //               <MobileSubLink to="/services/it-security" onClick={closeMobileMenu}>
// //                 <span>IT Security</span>
// //               </MobileSubLink>
// //             </MobileSubMenu>
            
// //             <MobileNavLink to="/career" onClick={closeMobileMenu} active={isActiveLink('/career')}>
// //               <span>Career</span>
// //               <FaChevronRight size={14} />
// //             </MobileNavLink>
            
// //             <MobileNavLink to="/contact" onClick={closeMobileMenu} active={isActiveLink('/contact')}>
// //               <span>Contact</span>
// //               <FaChevronRight size={14} />
// //             </MobileNavLink>
            
// //             <CTAButton 
// //               to="/contact" 
// //               onClick={closeMobileMenu} 
// //               style={{ 
// //                 marginTop: '2rem', 
// //                 marginBottom: '2rem',
// //                 textAlign: 'center', 
// //                 display: 'flex',
// //                 justifyContent: 'center',
// //                 alignItems: 'center',
// //                 flexShrink: 0
// //               }}
// //             >
// //               Get Started
// //             </CTAButton>
// //           </MobileNavContent>
// //         </MobileMenuOverlay>
// //       </HeaderContent>
// //     </HeaderContainer>
// //   );
// // };

// // export default Header;


// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import styled, { keyframes } from 'styled-components';
// import { 
//   FaBars, 
//   FaTimes, 
//   FaChevronDown,
//   FaChevronRight
// } from 'react-icons/fa';
// import logoimage from './images/VVV_IT.png';

// // Animations
// const fadeInDown = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(-20px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const fadeIn = keyframes`
//   from {
//     opacity: 0;
//   }
//   to {
//     opacity: 1;
//   }
// `;

// const slideInDown = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(-20px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// // Styled Components
// const HeaderContainer = styled.header`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   z-index: 1000;
//   background: ${props => props.scrolled ? 'rgba(255, 255, 255, 0.98)' : 'rgba(255, 255, 255, 0.95)'};
//   backdrop-filter: blur(20px);
//   box-shadow: ${props => props.scrolled ? '0 8px 32px rgba(0, 0, 0, 0.12)' : '0 4px 20px rgba(0, 0, 0, 0.08)'};
//   border-bottom: 1px solid rgba(255, 255, 255, 0.2);
//   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//   animation: ${fadeInDown} 0.6s ease-out;

//   @media (max-width: 768px) {
//     backdrop-filter: blur(30px);
//   }
// `;

// const HeaderContent = styled.div`
//   max-width: 1400px;
//   margin: 0 auto;
//   padding: 1rem 2rem;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   position: relative;

//   @media (max-width: 1024px) {
//     padding: 1rem 1.5rem;
//   }

//   @media (max-width: 768px) {
//     padding: 0.8rem 1.2rem;
//   }
// `;

// const LogoContainer = styled(Link)`
//   display: flex;
//   align-items: center;
//   gap: 1rem;
//   cursor: pointer;
//   text-decoration: none;
//   position: relative;
//   padding: 0.5rem;
//   border-radius: 12px;
//   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//   z-index: 1003;

//   &:hover {
//     transform: translateY(-2px);
    
//     img {
//       transform: scale(1.1) rotate(5deg);
//       filter: drop-shadow(0 6px 12px rgba(10, 35, 66, 0.25));
//     }
//   }
// `;

// const LogoImage = styled.img`
//   width: 65px;
//   height: 65px;
//   object-fit: contain;
//   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//   filter: drop-shadow(0 4px 8px rgba(10, 35, 66, 0.15));

//   @media (max-width: 768px) {
//     width: 55px;
//     height: 55px;
//   }

//   @media (max-width: 480px) {
//     width: 50px;
//     height: 50px;
//   }
// `;

// const LogoText = styled.div`
//   display: flex;
//   flex-direction: column;

//   @media (max-width: 1024px) {
//     display: none;
//   }
// `;

// const MobileLogoText = styled.div`
//   display: none;
//   flex-direction: column;

//   @media (max-width: 1024px) {
//     display: flex;
//   }

//   @media (max-width: 480px) {
//     display: none;
//   }
// `;

// const CompanyName = styled.div`
//   font-size: 1.4rem;
//   font-weight: 800;
//   color: #0A2342;
//   line-height: 1.1;
//   letter-spacing: -0.02em;
// `;

// const MobileCompanyName = styled.div`
//   font-size: 1.2rem;
//   font-weight: 800;
//   color: #0A2342;
//   line-height: 1.1;
//   letter-spacing: -0.02em;
// `;

// const CompanyTagline = styled.div`
//   font-size: 0.75rem;
//   color: #00A896;
//   font-weight: 600;
//   text-transform: uppercase;
//   letter-spacing: 1px;
//   margin-top: 2px;
// `;

// const MobileCompanyTagline = styled.div`
//   font-size: 0.7rem;
//   color: #00A896;
//   font-weight: 600;
//   text-transform: uppercase;
//   letter-spacing: 1px;
//   margin-top: 2px;
// `;

// const Nav = styled.nav`
//   display: flex;
//   gap: 2.5rem;
//   align-items: center;
//   position: relative;

//   @media (max-width: 1024px) {
//     gap: 2rem;
//   }

//   @media (max-width: 900px) {
//     display: none;
//   }
// `;

// const NavLink = styled(Link)`
//   color: ${props => props.active ? '#00A896' : '#334155'};
//   text-decoration: none;
//   font-weight: 600;
//   font-size: 1rem;
//   position: relative;
//   padding: 0.8rem 0;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   letter-spacing: -0.01em;
//   white-space: nowrap;

//   &::before {
//     content: '';
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     width: 100%;
//     height: 3px;
//     background: linear-gradient(90deg, #00A896, #005f56);
//     transform: scaleX(0);
//     transform-origin: right;
//     transition: transform 0.4s ease;
//     border-radius: 2px;
//   }

//   &:hover {
//     color: #00A896;
    
//     &::before {
//       transform: scaleX(1);
//       transform-origin: left;
//     }
//   }

//   &.active {
//     color: #00A896;
    
//     &::before {
//       transform: scaleX(1);
//     }
//   }
// `;

// const NavItem = styled.div`
//   position: relative;
//   display: flex;
//   align-items: center;
//   cursor: pointer;

//   &:hover > div {
//     opacity: 1;
//     visibility: visible;
//     transform: translateY(0);
//   }
// `;

// const DropdownMenu = styled.div`
//   position: absolute;
//   top: calc(100% + 10px);
//   left: 50%;
//   transform: translateX(-50%) translateY(-10px);
//   background: rgba(255, 255, 255, 0.98);
//   backdrop-filter: blur(20px);
//   min-width: 240px;
//   border-radius: 16px;
//   box-shadow: 
//     0 20px 40px rgba(0, 0, 0, 0.15),
//     0 0 0 1px rgba(0, 0, 0, 0.05);
//   padding: 12px 0;
//   z-index: 1000;
//   opacity: 0;
//   visibility: hidden;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   border: 1px solid rgba(255, 255, 255, 0.2);

//   &::before {
//     content: '';
//     position: absolute;
//     top: -6px;
//     left: 50%;
//     transform: translateX(-50%);
//     width: 0;
//     height: 0;
//     border-left: 6px solid transparent;
//     border-right: 6px solid transparent;
//     border-bottom: 6px solid rgba(255, 255, 255, 0.98);
//   }
// `;

// const DropdownItem = styled(Link)`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 12px 20px;
//   color: #334155;
//   text-decoration: none;
//   font-size: 0.95rem;
//   font-weight: 500;
//   transition: all 0.2s ease;
//   border-left: 3px solid transparent;

//   &:hover {
//     background: rgba(0, 168, 150, 0.08);
//     color: #00A896;
//     border-left-color: #00A896;
//     padding-left: 24px;

//     svg {
//       opacity: 1;
//       transform: translateX(3px);
//     }
//   }

//   svg {
//     opacity: 0;
//     transition: all 0.3s ease;
//     font-size: 0.8rem;
//   }
// `;

// const CTAButton = styled(Link)`
//   background: linear-gradient(135deg, #00A896, #008a79);
//   color: white;
//   padding: 0.9rem 2.2rem;
//   border-radius: 50px;
//   text-decoration: none;
//   font-weight: 700;
//   font-size: 1rem;
//   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//   box-shadow: 
//     0 8px 20px rgba(0, 168, 150, 0.3),
//     inset 0 1px 0 rgba(255, 255, 255, 0.2);
//   position: relative;
//   overflow: hidden;
//   letter-spacing: 0.3px;
//   border: none;
//   white-space: nowrap;

//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
//     transition: left 0.6s ease;
//   }

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 
//       0 12px 25px rgba(0, 168, 150, 0.4),
//       inset 0 1px 0 rgba(255, 255, 255, 0.2);
    
//     &::before {
//       left: 100%;
//     }
//   }

//   @media (max-width: 900px) {
//     padding: 0.8rem 1.8rem;
//     font-size: 0.95rem;
//   }
// `;

// const MobileMenuButton = styled.button`
//   display: none;
//   background: none;
//   border: none;
//   cursor: pointer;
//   padding: 0.8rem;
//   z-index: 1001;
//   color: #00A896;
//   transition: all 0.3s ease;
//   border-radius: 10px;
//   position: relative;

//   @media (max-width: 900px) {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }

//   &:hover {
//     background: rgba(0, 168, 150, 0.1);
//     transform: scale(1.05);
//   }
// `;

// const MobileMenuOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100vh;
//   background: rgba(255, 255, 255, 0.98);
//   backdrop-filter: blur(30px);
//   z-index: 998;
//   display: ${props => props.isOpen ? 'flex' : 'none'};
//   flex-direction: column;
//   align-items: center;
//   justify-content: flex-start;
//   padding-top: 5rem;
//   animation: ${fadeIn} 0.3s ease;
//   overflow: hidden;

//   @media (min-width: 901px) {
//     display: none;
//   }
// `;

// const MobileHeader = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   background: rgba(255, 255, 255, 0.98);
//   backdrop-filter: blur(20px);
//   border-bottom: 1px solid rgba(0, 0, 0, 0.1);
//   padding: 1rem 2rem;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   z-index: 1002;

//   @media (max-width: 480px) {
//     padding: 1rem 1.5rem;
//   }
// `;

// const CloseButton = styled.button`
//   background: none;
//   border: none;
//   color: #00A896;
//   cursor: pointer;
//   padding: 0.5rem;
//   line-height: 1;
//   transition: all 0.3s ease;
//   border-radius: 10px;
//   width: 45px;
//   height: 45px;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   &:hover {
//     transform: rotate(90deg) scale(1.1);
//     background: rgba(0, 168, 150, 0.1);
//   }
// `;

// const MobileNavContent = styled.div`
//   width: 100%;
//   max-width: 500px;
//   height: calc(100vh - 6rem);
//   padding: 0 2rem 2rem;
//   display: flex;
//   flex-direction: column;
//   align-items: stretch;
//   gap: 0;
//   overflow-y: auto;
//   -webkit-overflow-scrolling: touch;
//   margin-top: 4rem;

//   /* Scrollbar Styling */
//   &::-webkit-scrollbar {
//     width: 4px;
//   }

//   &::-webkit-scrollbar-track {
//     background: rgba(0, 0, 0, 0.05);
//     border-radius: 10px;
//   }

//   &::-webkit-scrollbar-thumb {
//     background: #00A896;
//     border-radius: 10px;
//   }

//   &::-webkit-scrollbar-thumb:hover {
//     background: #008a79;
//   }

//   @media (max-width: 480px) {
//     padding: 0 1.5rem 2rem;
//     height: calc(100vh - 5rem);
//     margin-top: 3.5rem;
//   }
// `;

// const MobileNavLink = styled(Link)`
//   color: ${props => props.active ? '#00A896' : '#334155'};
//   text-decoration: none;
//   font-weight: 600;
//   font-size: 1.2rem;
//   padding: 1.2rem 1rem;
//   border-bottom: 1px solid rgba(0, 0, 0, 0.08);
//   transition: all 0.3s ease;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   text-transform: none;
//   letter-spacing: normal;
//   animation: ${slideInDown} 0.4s ease;
//   flex-shrink: 0;

//   &:hover {
//     color: #00A896;
//     background: rgba(0, 168, 150, 0.05);
//     padding-left: 1.5rem;
//   }

//   &.active {
//     color: #00A896;
//     background: rgba(0, 168, 150, 0.08);
//   }

//   @media (max-width: 480px) {
//     font-size: 1.1rem;
//     padding: 1rem 1rem;
//   }
// `;

// const MobileSubMenu = styled.div`
//   display: ${props => props.isOpen ? 'flex' : 'none'};
//   flex-direction: column;
//   background: rgba(0, 0, 0, 0.02);
//   border-radius: 8px;
//   margin: 0.5rem 0;
//   overflow: hidden;
//   animation: ${slideInDown} 0.4s ease;
//   flex-shrink: 0;
// `;

// const MobileSubLink = styled(Link)`
//   color: #64748b;
//   text-decoration: none;
//   font-weight: 500;
//   font-size: 1rem;
//   padding: 1rem 1.5rem;
//   border-bottom: 1px solid rgba(0, 0, 0, 0.05);
//   transition: all 0.3s ease;
//   display: flex;
//   align-items: center;
//   text-transform: none;
//   letter-spacing: normal;
//   flex-shrink: 0;

//   &:hover {
//     color: #00A896;
//     background: rgba(0, 168, 150, 0.05);
//     padding-left: 2rem;
//   }

//   &:last-child {
//     border-bottom: none;
//   }
// `;

// const ServicesToggle = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   width: 100%;
//   cursor: pointer;
//   text-transform: none;
//   letter-spacing: normal;
// `;

// const MobileNavItem = styled.div`
//   color: ${props => props.active ? '#00A896' : '#334155'};
//   text-decoration: none;
//   font-weight: 600;
//   font-size: 1.2rem;
//   padding: 1.2rem 1rem;
//   border-bottom: 1px solid rgba(0, 0, 0, 0.08);
//   transition: all 0.3s ease;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   text-transform: none;
//   letter-spacing: normal;
//   cursor: pointer;
//   animation: ${slideInDown} 0.4s ease;
//   flex-shrink: 0;

//   &:hover {
//     color: #00A896;
//     background: rgba(0, 168, 150, 0.05);
//     padding-left: 1.5rem;
//   }

//   @media (max-width: 480px) {
//     font-size: 1.1rem;
//     padding: 1rem 1rem;
//   }
// `;

// const Header = () => {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
//   const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 10);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const closeMobileMenu = () => {
//     setIsMobileMenuOpen(false);
//     setIsMobileServicesOpen(false);
//   };

//   const isActiveLink = (path) => {
//     return location.pathname === path;
//   };

//   const toggleMobileServices = () => {
//     setIsMobileServicesOpen(!isMobileServicesOpen);
//   };

//   return (
//     <>
//       <HeaderContainer scrolled={isScrolled}>
//         <HeaderContent>
//           <LogoContainer to="/" onClick={closeMobileMenu}>
//             <LogoImage src={logoimage} alt="VVV IT Solutions Logo" />
//             <LogoText>
//               <CompanyName>VVV IT Solutions</CompanyName>
//               <CompanyTagline>Digital Innovation</CompanyTagline>
//             </LogoText>
//             <MobileLogoText>
//               <MobileCompanyName>VVV IT Solutions</MobileCompanyName>
//               <MobileCompanyTagline>Digital Innovation</MobileCompanyTagline>
//             </MobileLogoText>
//           </LogoContainer>

//           <Nav>
//             <NavLink to="/" active={isActiveLink('/')}>Home</NavLink>
//             <NavLink to="/about" active={isActiveLink('/about')}>About</NavLink>
//             <NavItem
//               onMouseEnter={() => setIsServicesDropdownOpen(true)}
//               onMouseLeave={() => setIsServicesDropdownOpen(false)}
//             >
//               <NavLink to="/services" active={isActiveLink('/services')}>
//                 Services <FaChevronDown size={12} style={{ marginLeft: '6px' }} />
//               </NavLink>
//               <DropdownMenu style={{ 
//                 opacity: isServicesDropdownOpen ? 1 : 0, 
//                 visibility: isServicesDropdownOpen ? 'visible' : 'hidden',
//                 transform: isServicesDropdownOpen ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(-10px)'
//               }}>
//                 <DropdownItem to="/services/web-development" onClick={() => setIsServicesDropdownOpen(false)}>
//                   Web Development
//                   <FaChevronRight />
//                 </DropdownItem>
//                 <DropdownItem to="/services/mobile-development" onClick={() => setIsServicesDropdownOpen(false)}>
//                   Mobile App Development
//                   <FaChevronRight />
//                 </DropdownItem>
//                 <DropdownItem to="/services/cloud-solutions" onClick={() => setIsServicesDropdownOpen(false)}>
//                   Cloud Solutions
//                   <FaChevronRight />
//                 </DropdownItem>
//                 <DropdownItem to="/services/it-security" onClick={() => setIsServicesDropdownOpen(false)}>
//                   IT Security
//                   <FaChevronRight />
//                 </DropdownItem>
//               </DropdownMenu>
//             </NavItem>
//             <NavLink to="/career" active={isActiveLink('/career')}>Career</NavLink>
//             <NavLink to="/contact" active={isActiveLink('/contact')}>Contact</NavLink>
//             <CTAButton to="/contact">Get Started</CTAButton>
//           </Nav>

//           <MobileMenuButton
//             onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//             aria-label="Toggle mobile menu"
//           >
//             {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//           </MobileMenuButton>
//         </HeaderContent>
//       </HeaderContainer>

//       <MobileMenuOverlay isOpen={isMobileMenuOpen}>
//         <MobileHeader>
//           <LogoContainer to="/" onClick={closeMobileMenu}>
//             <LogoImage src={logoimage} alt="VVV IT Solutions Logo" />
//             <MobileLogoText>
//               <MobileCompanyName>VVV IT Solutions</MobileCompanyName>
//               <MobileCompanyTagline>Digital Innovation</MobileCompanyTagline>
//             </MobileLogoText>
//           </LogoContainer>
          
//           <CloseButton onClick={closeMobileMenu} aria-label="Close mobile menu">
//             <FaTimes size={20} />
//           </CloseButton>
//         </MobileHeader>
        
//         <MobileNavContent>
//           <MobileNavLink to="/" onClick={closeMobileMenu} active={isActiveLink('/')}>
//             <span>Home</span>
//             <FaChevronRight size={14} />
//           </MobileNavLink>
          
//           <MobileNavLink to="/about" onClick={closeMobileMenu} active={isActiveLink('/about')}>
//             <span>About</span>
//             <FaChevronRight size={14} />
//           </MobileNavLink>
          
//           <MobileNavItem 
//             onClick={toggleMobileServices}
//             active={isActiveLink('/services')}
//           >
//             <ServicesToggle>
//               <span>Services</span>
//               <FaChevronRight 
//                 size={14} 
//                 style={{ 
//                   transform: isMobileServicesOpen ? 'rotate(90deg)' : 'rotate(0deg)',
//                   transition: 'transform 0.3s ease'
//                 }} 
//               />
//             </ServicesToggle>
//           </MobileNavItem>
          
//           <MobileSubMenu isOpen={isMobileServicesOpen}>
//             <MobileSubLink to="/services/web-development" onClick={closeMobileMenu}>
//               <span>Web Development</span>
//             </MobileSubLink>
//             <MobileSubLink to="/services/mobile-development" onClick={closeMobileMenu}>
//               <span>Mobile App Development</span>
//             </MobileSubLink>
//             <MobileSubLink to="/services/cloud-solutions" onClick={closeMobileMenu}>
//               <span>Cloud Solutions</span>
//             </MobileSubLink>
//             <MobileSubLink to="/services/it-security" onClick={closeMobileMenu}>
//               <span>IT Security</span>
//             </MobileSubLink>
//           </MobileSubMenu>
          
//           <MobileNavLink to="/career" onClick={closeMobileMenu} active={isActiveLink('/career')}>
//             <span>Career</span>
//             <FaChevronRight size={14} />
//           </MobileNavLink>
          
//           <MobileNavLink to="/contact" onClick={closeMobileMenu} active={isActiveLink('/contact')}>
//             <span>Contact</span>
//             <FaChevronRight size={14} />
//           </MobileNavLink>
          
//           <CTAButton 
//             to="/contact" 
//             onClick={closeMobileMenu} 
//             style={{ 
//               marginTop: '2rem', 
//               marginBottom: '2rem',
//               textAlign: 'center', 
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               flexShrink: 0
//             }}
//           >
//             Get Started
//           </CTAButton>
//         </MobileNavContent>
//       </MobileMenuOverlay>
//     </>
//   );
// };

// export default Header;

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { 
  FaBars, 
  FaTimes, 
  FaChevronDown,
  FaChevronRight,
  FaCheck
} from 'react-icons/fa';
import logoimage from './images/VVV_IT.png';
import { productMenuItems } from './data/productMenu';

const themeOptions = [
  { id: 'vvv', label: 'VVV Teal', swatch: '#00A896' },
  { id: 'midnight', label: 'Midnight', swatch: '#38bdf8' },
  { id: 'ocean', label: 'Ocean Blue', swatch: '#2563eb' },
  { id: 'cyber', label: 'Cyber Indigo', swatch: '#7c3aed' },
  { id: 'forest', label: 'Tech Forest', swatch: '#16a34a' }
];

const fontSizeOptions = [
  { id: 'small', label: 'Small', symbol: 'A-' },
  { id: 'medium', label: 'Medium', symbol: 'A' },
  { id: 'large', label: 'Large', symbol: 'A+' }
];

// Animations
const fadeInDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideInDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Styled Components
const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: ${props => props.$scrolled ? 'rgba(255, 255, 255, 0.98)' : 'rgba(255, 255, 255, 0.95)'};
  backdrop-filter: blur(20px);
  box-shadow: ${props => props.$scrolled ? '0 8px 32px rgba(0, 0, 0, 0.12)' : '0 4px 20px rgba(0, 0, 0, 0.08)'};
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: ${fadeInDown} 0.6s ease-out;

  @media (max-width: 768px) {
    backdrop-filter: blur(30px);
  }
`;

const HeaderContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  @media (max-width: 1024px) {
    padding: 1rem 1.5rem;
  }

  @media (max-width: 768px) {
    padding: 0.8rem 1.2rem;
  }
`;

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  padding: 0.5rem;
  border-radius: 12px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1003;

  &:hover {
    transform: translateY(-2px);
    
    img {
      transform: scale(1.1) rotate(5deg);
      filter: drop-shadow(0 6px 12px var(--theme-shadow-accent));
    }
  }
`;

const LogoImage = styled.img`
  width: 65px;
  height: 65px;
  object-fit: contain;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  filter: drop-shadow(0 4px 8px var(--theme-shadow-accent));

  @media (max-width: 768px) {
    width: 55px;
    height: 55px;
  }

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
  }
`;

const LogoText = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const MobileLogoText = styled.div`
  display: none;
  flex-direction: column;

  @media (max-width: 1024px) {
    display: flex;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

const CompanyName = styled.div`
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--theme-primary);
  line-height: 1.1;
  letter-spacing: -0.02em;
`;

const MobileCompanyName = styled.div`
  font-size: 1.2rem;
  font-weight: 800;
  color: var(--theme-primary);
  line-height: 1.1;
  letter-spacing: -0.02em;
`;

const CompanyTagline = styled.div`
  font-size: 0.75rem;
  color: var(--theme-accent);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 2px;
`;

const MobileCompanyTagline = styled.div`
  font-size: 0.7rem;
  color: var(--theme-accent);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 2px;
`;

const Nav = styled.nav`
  display: flex;
  gap: 2.5rem;
  align-items: center;
  position: relative;

  @media (max-width: 1024px) {
    gap: 2rem;
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

const NavLink = styled(Link)`
  color: ${props => props.$active ? 'var(--theme-accent)' : 'var(--theme-secondary)'};
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  position: relative;
  padding: 0.8rem 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: -0.01em;
  white-space: nowrap;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, var(--theme-accent), var(--theme-accent-strong));
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.4s ease;
    border-radius: 2px;
  }

  &:hover {
    color: var(--theme-accent);
    
    &::before {
      transform: scaleX(1);
      transform-origin: left;
    }
  }

  &.active {
    color: var(--theme-accent);
    
    &::before {
      transform: scaleX(1);
    }
  }
`;

const NavItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover > div {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%) translateY(-10px);
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  min-width: 240px;
  border-radius: 16px;
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  padding: 12px 0;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.2);

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid rgba(255, 255, 255, 0.98);
  }
`;

const DropdownItem = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  color: var(--theme-secondary);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;

  &:hover {
    background: var(--theme-accent-soft);
    color: var(--theme-accent);
    border-left-color: var(--theme-accent);
    padding-left: 24px;

    svg {
      opacity: 1;
      transform: translateX(3px);
    }
  }

  svg {
    opacity: 0;
    transition: all 0.3s ease;
    font-size: 0.8rem;
  }
`;

const CTAButton = styled(Link)`
  background: linear-gradient(135deg, var(--theme-accent), var(--theme-accent-strong));
  color: white;
  padding: 0.9rem 2.2rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 8px 20px var(--theme-shadow-accent),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
  letter-spacing: 0.3px;
  border: none;
  white-space: nowrap;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 12px 25px var(--theme-shadow-accent),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    
    &::before {
      left: 100%;
    }
  }

  @media (max-width: 900px) {
    padding: 0.8rem 1.8rem;
    font-size: 0.95rem;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.8rem;
  z-index: 1001;
  color: var(--theme-accent);
  transition: all 0.3s ease;
  border-radius: 10px;
  position: relative;

  @media (max-width: 900px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    background: var(--theme-accent-soft);
    transform: scale(1.05);
  }
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
`;

const ThemeControlWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const SettingsButton = styled.button`
  min-width: 96px;
  height: 46px;
  padding: 0 1.2rem;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: linear-gradient(135deg, var(--theme-accent), var(--theme-accent-strong));
  color: var(--theme-accent);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  color: #ffffff;
  font-weight: 800;
  font-size: 0.95rem;
  letter-spacing: 0;
  box-shadow: 0 10px 24px var(--theme-shadow-accent);
  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 30px var(--theme-shadow-accent);
  }

  @media (max-width: 1024px) {
    min-width: 88px;
    padding: 0 1rem;
  }
`;

const SettingsPanel = styled.div`
  position: absolute;
  top: calc(100% + 16px);
  right: 0;
  width: 330px;
  max-width: calc(100vw - 2rem);
  background: rgba(255, 255, 255, 0.98);
  color: var(--theme-secondary);
  border: 1px solid var(--theme-border);
  border-radius: 18px;
  box-shadow: 0 24px 55px rgba(15, 23, 42, 0.16);
  overflow: hidden;
  z-index: 1200;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-8px)'};
  transition: opacity 0.22s ease, transform 0.22s ease, visibility 0.22s ease;
`;

const SettingsSection = styled.div`
  padding: 1.1rem 1.25rem;
  border-bottom: 1px solid var(--theme-border);

  &:last-child {
    border-bottom: none;
  }
`;

const SettingsLabel = styled.div`
  color: var(--theme-accent-strong);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  margin-bottom: 0.8rem;
  text-transform: uppercase;
`;

const SettingOption = styled.button`
  width: 100%;
  border: none;
  background: ${props => props.$active ? 'var(--theme-accent-soft)' : 'transparent'};
  color: var(--theme-secondary);
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0.85rem 0.75rem;
  text-align: left;
  font-size: 0.98rem;
  font-weight: 700;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: var(--theme-accent-soft);
    color: var(--theme-primary);
  }
`;

const OptionBadge = styled.span`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: ${props => props.$swatch || 'var(--theme-accent-soft)'};
  color: ${props => props.$swatch ? '#ffffff' : 'var(--theme-accent-strong)'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  flex: 0 0 auto;
  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.35);
`;

const OptionCheck = styled.span`
  margin-left: auto;
  color: var(--theme-accent-strong);
  display: inline-flex;
  align-items: center;
`;

const MobileSettingsBlock = styled.div`
  margin: 1rem 0;
  border: 1px solid var(--theme-border);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.76);
  overflow: hidden;
  flex-shrink: 0;
`;

const MobileMenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(30px);
  z-index: 998;
  display: ${props => props.$isOpen ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 5rem;
  animation: ${fadeIn} 0.3s ease;
  overflow: hidden;

  @media (min-width: 901px) {
    display: none;
  }
`;

const MobileHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1002;

  @media (max-width: 480px) {
    padding: 1rem 1.5rem;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: var(--theme-accent);
  cursor: pointer;
  padding: 0.5rem;
  line-height: 1;
  transition: all 0.3s ease;
  border-radius: 10px;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: rotate(90deg) scale(1.1);
    background: var(--theme-accent-soft);
  }
`;

const MobileNavContent = styled.div`
  width: 100%;
  max-width: 500px;
  height: calc(100vh - 6rem);
  padding: 0 2rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 4rem;

  /* Scrollbar Styling */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--theme-accent);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--theme-accent-strong);
  }

  @media (max-width: 480px) {
    padding: 0 1.5rem 2rem;
    height: calc(100vh - 5rem);
    margin-top: 3.5rem;
  }
`;

const MobileNavLink = styled(Link)`
  color: ${props => props.$active ? 'var(--theme-accent)' : 'var(--theme-secondary)'};
  text-decoration: none;
  font-weight: 600;
  font-size: 1.2rem;
  padding: 1.2rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: none;
  letter-spacing: normal;
  animation: ${slideInDown} 0.4s ease;
  flex-shrink: 0;

  &:hover {
    color: var(--theme-accent);
    background: var(--theme-accent-soft);
    padding-left: 1.5rem;
  }

  &.active {
    color: var(--theme-accent);
    background: var(--theme-accent-soft);
  }

  @media (max-width: 480px) {
    font-size: 1.1rem;
    padding: 1rem 1rem;
  }
`;

const MobileSubMenu = styled.div`
  display: ${props => props.$isOpen ? 'flex' : 'none'};
  flex-direction: column;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  margin: 0.5rem 0;
  overflow: hidden;
  animation: ${slideInDown} 0.4s ease;
  flex-shrink: 0;
`;

const MobileSubLink = styled(Link)`
  color: #64748b;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  text-transform: none;
  letter-spacing: normal;
  flex-shrink: 0;

  &:hover {
    color: var(--theme-accent);
    background: var(--theme-accent-soft);
    padding-left: 2rem;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const ServicesToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  text-transform: none;
  letter-spacing: normal;
`;

const MobileNavItem = styled.div`
  color: ${props => props.$active ? 'var(--theme-accent)' : 'var(--theme-secondary)'};
  text-decoration: none;
  font-weight: 600;
  font-size: 1.2rem;
  padding: 1.2rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: none;
  letter-spacing: normal;
  cursor: pointer;
  animation: ${slideInDown} 0.4s ease;
  flex-shrink: 0;

  &:hover {
    color: var(--theme-accent);
    background: var(--theme-accent-soft);
    padding-left: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 1.1rem;
    padding: 1rem 1rem;
  }
`;

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const [isMobileProductsOpen, setIsMobileProductsOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState('vvv');
  const [selectedFontSize, setSelectedFontSize] = useState('medium');
  const location = useLocation();

  useEffect(() => {
    const storedTheme = window.localStorage.getItem('vvv-theme') || 'vvv';
    const storedFontSize = window.localStorage.getItem('vvv-font-size') || 'medium';

    setSelectedTheme(storedTheme);
    setSelectedFontSize(storedFontSize);
    document.body.dataset.theme = storedTheme;
    document.documentElement.dataset.fontSize = storedFontSize;
  }, []);

  useEffect(() => {
    document.body.dataset.theme = selectedTheme;
    window.localStorage.setItem('vvv-theme', selectedTheme);
  }, [selectedTheme]);

  useEffect(() => {
    document.documentElement.dataset.fontSize = selectedFontSize;
    window.localStorage.setItem('vvv-font-size', selectedFontSize);
  }, [selectedFontSize]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMobileServicesOpen(false);
    setIsMobileProductsOpen(false);
    setIsSettingsOpen(false);
  };

  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  const isProductsActive = () => {
    return location.pathname.startsWith('/products/');
  };

  const toggleMobileServices = () => {
    setIsMobileServicesOpen(!isMobileServicesOpen);
  };

  const toggleMobileProducts = () => {
    setIsMobileProductsOpen(!isMobileProductsOpen);
  };

  const renderSettingsControls = () => (
    <>
      <SettingsSection>
        <SettingsLabel>Theme</SettingsLabel>
        {themeOptions.map((theme) => (
          <SettingOption
            key={theme.id}
            type="button"
            $active={selectedTheme === theme.id}
            onClick={() => setSelectedTheme(theme.id)}
          >
            <OptionBadge $swatch={theme.swatch} />
            <span>{theme.label}</span>
            {selectedTheme === theme.id ? (
              <OptionCheck><FaCheck size={13} /></OptionCheck>
            ) : null}
          </SettingOption>
        ))}
      </SettingsSection>
      <SettingsSection>
        <SettingsLabel>Font Size</SettingsLabel>
        {fontSizeOptions.map((fontSize) => (
          <SettingOption
            key={fontSize.id}
            type="button"
            $active={selectedFontSize === fontSize.id}
            onClick={() => setSelectedFontSize(fontSize.id)}
          >
            <OptionBadge>{fontSize.symbol}</OptionBadge>
            <span>{fontSize.label}</span>
            {selectedFontSize === fontSize.id ? (
              <OptionCheck><FaCheck size={13} /></OptionCheck>
            ) : null}
          </SettingOption>
        ))}
      </SettingsSection>
    </>
  );

  return (
    <>
      <HeaderContainer $scrolled={isScrolled}>
        <HeaderContent>
          <LogoContainer to="/" onClick={closeMobileMenu}>
            <LogoImage src={logoimage} alt="VVV IT Solutions Logo" />
            <LogoText>
              <CompanyName>VVV IT Solutions</CompanyName>
              <CompanyTagline>Digital Innovation</CompanyTagline>
            </LogoText>
            <MobileLogoText>
              <MobileCompanyName>VVV IT Solutions</MobileCompanyName>
              <MobileCompanyTagline>Digital Innovation</MobileCompanyTagline>
            </MobileLogoText>
          </LogoContainer>

          <Nav>
            <NavLink to="/" $active={isActiveLink('/')}>Home</NavLink>
            <NavLink to="/about" $active={isActiveLink('/about')}>About</NavLink>
            <NavItem
              onMouseEnter={() => setIsServicesDropdownOpen(true)}
              onMouseLeave={() => setIsServicesDropdownOpen(false)}
            >
              <NavLink to="/services" $active={isActiveLink('/services')}>
                Services <FaChevronDown size={12} style={{ marginLeft: '6px' }} />
              </NavLink>
              <DropdownMenu style={{ 
                opacity: isServicesDropdownOpen ? 1 : 0, 
                visibility: isServicesDropdownOpen ? 'visible' : 'hidden',
                transform: isServicesDropdownOpen ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(-10px)'
              }}>
                <DropdownItem to="/services/web-development" onClick={() => setIsServicesDropdownOpen(false)}>
                  Web Development
                  <FaChevronRight />
                </DropdownItem>
                <DropdownItem to="/services/mobile-development" onClick={() => setIsServicesDropdownOpen(false)}>
                  Mobile App Development
                  <FaChevronRight />
                </DropdownItem>
                <DropdownItem to="/services/cloud-solutions" onClick={() => setIsServicesDropdownOpen(false)}>
                  Cloud Solutions
                  <FaChevronRight />
                </DropdownItem>
                <DropdownItem to="/services/it-security" onClick={() => setIsServicesDropdownOpen(false)}>
                  IT Security
                  <FaChevronRight />
                </DropdownItem>
              </DropdownMenu>
            </NavItem>
            <NavItem
              onMouseEnter={() => setIsProductsDropdownOpen(true)}
              onMouseLeave={() => setIsProductsDropdownOpen(false)}
            >
              <NavLink to="/products/kiosk" $active={isProductsActive()}>
                Products <FaChevronDown size={12} style={{ marginLeft: '6px' }} />
              </NavLink>
              <DropdownMenu style={{
                opacity: isProductsDropdownOpen ? 1 : 0,
                visibility: isProductsDropdownOpen ? 'visible' : 'hidden',
                transform: isProductsDropdownOpen ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(-10px)',
                maxHeight: '70vh',
                overflowY: 'auto'
              }}>
                {productMenuItems.map((product) => (
                  <DropdownItem
                    key={product.slug}
                    to={`/products/${product.slug}`}
                    onClick={() => setIsProductsDropdownOpen(false)}
                  >
                    <span style={{ maxWidth: '180px', whiteSpace: 'normal', lineHeight: 1.35 }}>
                      {product.label}
                    </span>
                    <FaChevronRight />
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </NavItem>
            <NavLink to="/career" $active={isActiveLink('/career')}>Career</NavLink>
            <NavLink to="/contact" $active={isActiveLink('/contact')}>Contact</NavLink>
            <HeaderActions>
              <ThemeControlWrapper>
                <SettingsButton
                  type="button"
                  aria-label="Open theme and font settings"
                  onClick={() => setIsSettingsOpen(!isSettingsOpen)}
                >
                  Theme
                </SettingsButton>
                <SettingsPanel $isOpen={isSettingsOpen}>
                  {renderSettingsControls()}
                </SettingsPanel>
              </ThemeControlWrapper>
              <CTAButton to="/contact">Get Started</CTAButton>
            </HeaderActions>
          </Nav>

          <MobileMenuButton
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </MobileMenuButton>
        </HeaderContent>
      </HeaderContainer>

      <MobileMenuOverlay $isOpen={isMobileMenuOpen}>
        <MobileHeader>
          <LogoContainer to="/" onClick={closeMobileMenu}>
            <LogoImage src={logoimage} alt="VVV IT Solutions Logo" />
            <MobileLogoText>
              <MobileCompanyName>VVV IT Solutions</MobileCompanyName>
              <MobileCompanyTagline>Digital Innovation</MobileCompanyTagline>
            </MobileLogoText>
          </LogoContainer>
          
          <CloseButton onClick={closeMobileMenu} aria-label="Close mobile menu">
            <FaTimes size={20} />
          </CloseButton>
        </MobileHeader>
        
        <MobileNavContent>
          <MobileNavLink to="/" onClick={closeMobileMenu} $active={isActiveLink('/')}>
            <span>Home</span>
            <FaChevronRight size={14} />
          </MobileNavLink>
          
          <MobileNavLink to="/about" onClick={closeMobileMenu} $active={isActiveLink('/about')}>
            <span>About</span>
            <FaChevronRight size={14} />
          </MobileNavLink>
          
          <MobileNavItem 
            onClick={toggleMobileServices}
            $active={isActiveLink('/services')}
          >
            <ServicesToggle>
              <span>Services</span>
              <FaChevronRight 
                size={14} 
                style={{ 
                  transform: isMobileServicesOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }} 
              />
            </ServicesToggle>
          </MobileNavItem>
          
          <MobileSubMenu $isOpen={isMobileServicesOpen}>
            <MobileSubLink to="/services/web-development" onClick={closeMobileMenu}>
              <span>Web Development</span>
            </MobileSubLink>
            <MobileSubLink to="/services/mobile-development" onClick={closeMobileMenu}>
              <span>Mobile App Development</span>
            </MobileSubLink>
            <MobileSubLink to="/services/cloud-solutions" onClick={closeMobileMenu}>
              <span>Cloud Solutions</span>
            </MobileSubLink>
            <MobileSubLink to="/services/it-security" onClick={closeMobileMenu}>
              <span>IT Security</span>
            </MobileSubLink>
          </MobileSubMenu>

          <MobileNavItem
            onClick={toggleMobileProducts}
            $active={isProductsActive()}
          >
            <ServicesToggle>
              <span>Products</span>
              <FaChevronRight
                size={14}
                style={{
                  transform: isMobileProductsOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              />
            </ServicesToggle>
          </MobileNavItem>

          <MobileSubMenu $isOpen={isMobileProductsOpen}>
            {productMenuItems.map((product) => (
              <MobileSubLink
                key={product.slug}
                to={`/products/${product.slug}`}
                onClick={closeMobileMenu}
              >
                <span>{product.label}</span>
              </MobileSubLink>
            ))}
          </MobileSubMenu>
          
          <MobileNavLink to="/career" onClick={closeMobileMenu} $active={isActiveLink('/career')}>
            <span>Career</span>
            <FaChevronRight size={14} />
          </MobileNavLink>
          
          <MobileNavLink to="/contact" onClick={closeMobileMenu} $active={isActiveLink('/contact')}>
            <span>Contact</span>
            <FaChevronRight size={14} />
          </MobileNavLink>

          <MobileSettingsBlock>
            {renderSettingsControls()}
          </MobileSettingsBlock>
          
          <CTAButton 
            to="/contact" 
            onClick={closeMobileMenu} 
            style={{ 
              marginTop: '2rem', 
              marginBottom: '2rem',
              textAlign: 'center', 
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: 0
            }}
          >
            Get Started
          </CTAButton>
        </MobileNavContent>
      </MobileMenuOverlay>
    </>
  );
};

export default Header;
